export function roceTargetFromCriteria(criteria = {}) {
  const configuredCriteria = [
    [criteria.primaryMetric, criteria.primaryThreshold],
    [criteria.secondaryMetric, criteria.secondaryThreshold],
  ]

  const roceCriterion = configuredCriteria.find(([metric, threshold]) => (
    String(metric ?? '').toLowerCase() === 'roce' &&
    String(threshold ?? '').trim() !== ''
  ))

  return String(roceCriterion?.[1] ?? '').trim()
}
